import New from "csi/table/New";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";
import StructureItemMixin from "src/Apparel/StructureItemMixin";

/** @property {string} STYLE - the hierarchy level used for comparision */
const STYLE = "Style";

const NewEngineeringChangeOnHierarchy = declare([New, StructureItemMixin], {

	/** @property {string} hierarchyLevel- the current level of hierarchy */
	hierarchyLevel: "",

	/**
	 * @override
	 * Allow controller to add parameters to popup view
	 */
	onCreatePopupParams(params) {
		params.productLabel = STYLE;
		this.hierarchyLevel = this._resolveViewRelation(this.widget);
		params.productStore = this._getHierarchyStore(this.hierarchyLevel, this.m_urlParent);
	},

	/**
	* @override
	* On style node, make the style as default & selected on engineering change form
	*/
	onCreatePopup(view) {
		if (this.hierarchyLevel === STYLE) {
			view.addFixedValue(STYLE, this.m_urlParent);
		}
		this.inherited(arguments);
	},

	/**
	 * @override
	 * Style is marked to be taken care on the server side
	 */
	toWriterRequest(fd: FormData): CallMethod {
		const call = this.inherited<CallMethod>(arguments);
		const styleURLs = this.m_formData.getFieldValue(STYLE, true);
		call.addParameter("AddURLs", xml.ATTR_REFLIST, styleURLs);
		return call;
	},
});

export = NewEngineeringChangeOnHierarchy;